"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MESSAGES = void 0;
var MESSAGES = {
  INTERNAL_SERVER_ERR: 'Internal server error: Try refreshing the page',
  CLIENT_SIDE_ERR: 'Oops, error!: Something went wrong',
  PERMISSION_DENIED_ERR: 'Permission denied'
};
exports.MESSAGES = MESSAGES;